import get from 'lodash/get';
import trim from 'lodash/trim';
const withPrefix = require('./withPrefix').default;

// TODO: Generalize function and reuse (V.T. 31.1.2022)
export default function CategoryUrl(category) {
	const slug = trim(get(category, 'slug'), '/');
	return withPrefix(`/blog/category/${slug}`);
}
